<template>
  <CRow>
    <CCol>
      <div v-if="serverErrors.length">
        <CAlert
          v-model="showDismissibleAlert"
          color="danger"
          closeButton
          v-for="err in serverErrors"
          :key="err"
        >
          {{ err }}
        </CAlert>
      </div>
      <validation-observer ref="formValidator">
        <form v-on:submit.prevent="updateMeter">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Projects</label>
                <multiselect
                    v-model="newMeter.project"
                    :options="projectsList"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Select Project"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                >
                  <template
                      slot="selection"
                      slot-scope="{ values, search, isOpen }"
                  ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                  ></template
                  >
                </multiselect>
              </div>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                vid="batch_no"
                name="Batch No"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Batch No.</label>
                  <CInput
                    type="number"
                    v-model="newMeter.batch_no"
                    placeholder="Enter Batch No."
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                  />
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                name="Category"
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Category</label>
                  <select
                    class="form-control"
                    v-model="newMeter.category_id"
                    required
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                  >
                    <option value="">Select Category</option>
                    <option v-bind:value="1">Water Meter</option>
                  </select>
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                  name="Size of Conn."
                  :rules="{ required: true }"
                  v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Size of Conn.</label>
                  <select
                      :class="errors.length ? 'is-invalid' : ''"
                      name="connection_type"
                      v-model="newMeter.connection_size"
                      class="form-control"
                      required
                  >
                    <option value="">Select</option>
                    <option v-for="(meter_size, key) in constants.meter_sizes" :value="key">{{ meter_size }}</option>
                  </select>
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-md-6">
            <div class="form-group">
              <label>Meter Number</label>
              <input
                type="text"
                class="form-control"
                v-model="meter.meter_number"
                placeholder="Enter meter number"
                required
              />
            </div>
          </div> -->
            <div class="col-md-6">
              <ValidationProvider
                vid="hardware_serial_no"
                name="Meter Serial No"
                :rules="{ required: true, min: 4 }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Meter Serial No.</label>
                  <CInput
                    type="text"
                    v-model="newMeter.hardware_serial_no"
                    placeholder="Enter Serial No."
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                    required
                  >
                  </CInput>
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <div class="col-md-6">
              <ValidationProvider
                name="Brand Name"
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Brand Name</label>
                  <CInput
                    type="text"
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                    v-model="newMeter.brand_name"
                    placeholder="Enter Brand Name"
                    required
                  />
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                name="Model Number"
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Model Number</label>
                  <CInput
                    type="text"
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                    v-model="newMeter.model_number"
                    placeholder="Model number"
                    required
                  />
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Manufacture Year</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="newMeter.manufacture_year"
                  placeholder="Manufacture Year"
                  required
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Expire Date</label>
                <el-date-picker
                    required
                    class="w-100 p-0"
                    v-model="newMeter.expiry_date"
                    type="date"
                    placeholder="Expire Date"
                    :format="$datePickerFormat"
                    value-format="yyyy-MM-dd"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>IP Standard</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newMeter.ip_standard_code"
                  placeholder="IP Standard"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Max Pressure</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newMeter.max_pressure"
                  placeholder="Max Pressure"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Radio Frequency</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="newMeter.radio_frequency"
                    placeholder="Radio Frequency"
                />
              </div>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                  name="Meter Type"
                  :rules="{ required: false }"
                  v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Meter Type</label>
                  <select
                      :class="errors.length ? 'is-invalid' : ''"
                      name="class"
                      v-model="newMeter.meter_type"
                      class="form-control"
                  >
                    <option value="">Select</option>
                    <option v-for="(meter_type, typeKey) in constants.meter_type" :value="typeKey">{{ meter_type }}</option>
                  </select>
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                  name="Meter Status"
                  :rules="{ required: false }"
                  v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Meter Status</label>
                  <select
                      :class="errors.length ? 'is-invalid' : ''"
                      name="class"
                      v-model="newMeter.meter_status"
                      class="form-control"
                  >
                    <option value="">Select</option>
                    <option v-for="(meter_status, statusKey) in constants.meter_status" :value="statusKey">{{ meter_status }}</option>
                  </select>
                </div>
                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                name="Meter digit width"
                :rules="{ required: false }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Meter digit width</label>
                  <CInput
                    type="text"
                    v-model="newMeter.meter_digit_width"
                    placeholder="Meter digit width"
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                  />
                </div>

                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                name="Device EUI"
                :rules="{ required: false }"
                v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Device EUI</label>
                  <CInput
                    type="text"
                    v-model="newMeter.dev_eui"
                    placeholder="Device EUI"
                    :addInputClasses="errors.length ? 'is-invalid' : ''"
                  />
                </div>

                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                  name="Lora App Key"
                  :rules="{ required: false }"
                  v-slot="{ errors }"
              >
                <div class="form-group">
                  <label>Lora App Key</label>
                  <CInput
                      type="text"
                      v-model="newMeter.lora_app_key"
                      placeholder="Lora App Key"
                      :addInputClasses="errors.length ? 'is-invalid' : ''"
                  />
                </div>

                <p class="text-danger mt-0 pt-0">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>
          </div>
          <button type="submit" class="btn btn-primary">Submit</button>
        </form>
      </validation-observer>
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect    from "vue-multiselect";

export default {
  name: "EditMeter",
  props: [
      "meterId", "meter", "constants"
  ],
  data: () => {
    return {
      serverErrors: [],
      showDismissibleAlert: false,
      isLoading: false,
      newMeter: {
        project: {},
        category_id: 1,
        connection_size: "",
        meter_number: "",
        batch_no: "",
        hardware_serial_no: "",
        description: "",
        brand_name: "",
        model_number: "",
        manufacture_year: moment().format("YYYY"),
        expiry_date: "",
        ip_standard_code: "",
        max_pressure: "",
        meter_type: "",
        meter_status: "",
        meter_digit_width: "",
        radio_frequency: "",
        dev_eui: "",
        lora_app_key: "",
      },
    };
  },
  components: {
    Multiselect,
  },
  computed  : {
    ...mapGetters("Projects", ["projectsList"]),
  },
  methods: {
    updateMeter() {
      this.newMeter.project_id = this.newMeter.project ? this.newMeter .project.id : "";
      this.$store
        .dispatch("Meter/update", this.newMeter)
        .then(() => {
          this.showToast = true;
          this.$toastr.s(
            "success",
            "Meter successfully updated.",
            "Meter Updated"
          );
          this.$emit("onEditedMeter");
        })
        .catch((err) => {
          this.showDismissibleAlert = true;
          this.serverErrors = [];
          if (err.response.data.message) {
            this.serverErrors.push(err.response.data.message);
            this.$refs.formValidator.setErrors(err.response.data.errors);
          }
        });
    },
  },
  mounted() {
    this.newMeter = { ...this.meter };
    this.$store.dispatch("Projects/getProjectsList");
  },
};
</script>

<style scoped lang="scss">
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
